import React, { useEffect } from "react";
import "./customersSupport.css";
import { Link } from "react-router-dom";
import customerSupport from "../../assets/images/Customer-Support-Team.jpg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faGlobe, faTruck, faUndo } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";


export default function CustomerSupport() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>SHOP.CO | Customer Support - We're Here to Help</title>
                <meta
                    name="description"
                    content="Need help? Contact SHOP.CO customer support for assistance with orders, accounts, payments, and delivery questions."
                />

                <link
                    rel="canonical"
                    href="https://shop-co-roan.vercel.app/help/customers-support/"
                />
            </Helmet>
            <div className="customersSupport-container">
                <div className="customersSupport-hero">
                    <div className="customersSupport-text">
                        <h1>We're Here to Help</h1>
                        <p>
                            Whether you need help with your order, returns, or just have a question,
                            our support team is ready to assist you every step of the way.
                        </p>
                        <a href="mailto:hr@yourdomain.com">
                            <button className="customersSupport-btn">Contact Support</button>
                        </a>
                    </div>
                    <div className="customersSupport-image">
                        <img
                            src={customerSupport}
                            alt="Customer Support"
                        />
                    </div>
                </div>


                <div className="customersSupport-faq">
                    <h2>Frequently Asked Questions</h2>
                    <div className="customersSupport-grid">
                        <div className="customersSupport-item">
                            <FontAwesomeIcon icon={faTruck} className="customersSupport-icon" />
                            <div>
                                <h4>How can I track my order?</h4>
                                <p>You can track your order from your profile under "My Orders".</p>
                            </div>
                        </div>
                        <div className="customersSupport-item">
                            <FontAwesomeIcon icon={faUndo} className="customersSupport-icon" />
                            <div>
                                <h4>How do I return a product?</h4>
                                <p>Visit the Returns section and follow the simple steps listed there.</p>
                            </div>
                        </div>
                        <div className="customersSupport-item">
                            <FontAwesomeIcon icon={faGlobe} className="customersSupport-icon" />
                            <div>
                                <h4>Do you offer international shipping?</h4>
                                <p>Yes! We ship worldwide with various delivery options.</p>
                            </div>
                        </div>
                        <div className="customersSupport-item">
                            <FontAwesomeIcon icon={faBan} className="customersSupport-icon" />
                            <div>
                                <h4>Can I cancel my order?</h4>
                                <p>Orders can be canceled before they are shipped. Check your order status.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}
